import {
    REMOVE_FOLDER_TREE,
    REMOVE_JSTREE_STATUS,
    REMOVE_FILE_CONTEXT_MENU,
    REMOVE_SHARE_FILE,
    REMOVE_FILE_PATH,
    GET_FOLDER_TREE,
    SET_FILE_CONTEXT_MENU,
    SET_SHARE_FILE,
    SET_FILE_PATH,
    SET_JSTREE_STATUS,
    REMOVE_FOLDER_TREE_LOADING,
    SET_FOLDER_TREE_LOADING,
    UPDATE_FILE_STATUS,
    REMOVE_FILE_STATUS_TRACKING
} from '../../types';

const initialState = {
    FolderTree: '',
    ContextMenu: [],
    ShareFile: {},
    FilePath: {},
    JsTreeStatus: { uploaded: false },
    FileStatus: {},
    FolderTreeLoading: false
};

export default function (state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case GET_FOLDER_TREE:
            return {
                ...state,
                FolderTree: payload
            };
        case REMOVE_FOLDER_TREE:
            return {
                ...state,
                FolderTree: ''
            };
        case SET_FILE_CONTEXT_MENU:
            return {
                ...state,
                ContextMenu: [...payload]
            };
        case REMOVE_FILE_CONTEXT_MENU:
            return {
                ...state,
                ContextMenu: []
            };
        case SET_SHARE_FILE:
            return {
                ...state,
                ShareFile: payload
            };
        case REMOVE_SHARE_FILE:
            return {
                ...state,
                ShareFile: ''
            };
        case SET_FILE_PATH:
            return {
                ...state,
                FilePath: payload
            };
        case REMOVE_FILE_PATH:
            return {
                ...state,
                FilePath: ''
            };
        case SET_JSTREE_STATUS:
        case REMOVE_JSTREE_STATUS: {
            const { name, value } = payload;
            return {
                ...state,
                JsTreeStatus: {
                    ...state.JsTreeStatus,
                    [name]: value
                }
            };
        }
        case SET_FOLDER_TREE_LOADING:
            return {
                ...state,
                FolderTreeLoading: true
            };
        case REMOVE_FOLDER_TREE_LOADING:
            return {
                ...state,
                FolderTreeLoading: false
            };
        case UPDATE_FILE_STATUS:
            return {
                ...state,
                FileStatus: {
                    [payload.filepath]: {
                        ...state.FileStatus[payload.filepath],
                        status: payload.status,
                        newName: payload.newName
                    }
                }
            };
        case REMOVE_FILE_STATUS_TRACKING:
            delete state.FileStatus[payload];
        default:
            return state;
    }
}